<template>
  <div :class="$style.base">
    <div :class="$style.row">
      <div>{{ $t('voucher.giftcard') }}</div>
      <div v-test="'giftcard-summary-amount'">
        {{ currency(giftcardAmount) }}
      </div>
    </div>
    <div v-if="settings.online_payment_charge" :class="$style.row">
      <div>{{ $t('general.payment_charge') }}</div>
      <div>
        {{ currency(settings.online_payment_charge) }}
      </div>
    </div>
    <div v-if="settings.online_payment_charge" :class="$style.row">
      <div>{{ $t('general.total') }}</div>
      <div>
        {{ currency(giftcardAmount + settings.online_payment_charge) }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { currency } from '@/helpers';
import { useBookingStore } from '@/stores/booking';
import { useCompanyStore } from '@/stores/company';

const { giftcardAmount } = useBookingStore();
const { settings } = useCompanyStore();
</script>

<style lang="scss" module>
.base {
  margin: $spacing 0 $spacing * 2;
  border: 1px solid $color-border;
  background-color: white;
  padding: $spacing;
  border-radius: $border-radius;
}

.row {
  display: flex;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: $spacing * 0.5;
  }

  &:last-child {
    font-weight: bold;
  }
}
</style>
